var render = function (_h,_vm) {var _c=_vm._c;return _c('vs-button',{staticClass:"buy-now",attrs:{"color":"danger","type":"filled","target":"","href":{url: 'https://1.envato.market/vuexy_admin'}}},[_vm._v("Buy Now")])}
var staticRenderFns = []

export { render, staticRenderFns }